import React from 'react'
import { SideBarContainer } from './styles'
import { SideToggleBar } from './styles';
import {
  FourGridIcon,
  NineGridIcon,
} from '../../Shared/SvgIcons'
import HyperTooltip from '../../Shared/HyperTooltip';

export const SideBar = (props) => {
  const {
    isMoreView,
    handleMoreView
  } = props

  return (
    <SideBarContainer>
      <SideToggleBar>
        <div
          className='grid-sharp active'
          onClick={() => handleMoreView()}
        >
          <HyperTooltip text="Grid View" direction="left">
            {isMoreView ? (
              <FourGridIcon />
            ) : (
              <NineGridIcon />
            )}
          </HyperTooltip>
        </div>
      </SideToggleBar>
    </SideBarContainer>
  )
}